import { InjectionToken } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export const USER_START_OF_WEEK$ = new InjectionToken<BehaviorSubject<number>>('userStartOfWeek');
